import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import Footer from '../components/Footer';
import Header from '../Header';
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import Logo from "../../../assets/logo.png";

const MyOrders = () => {
    const navigate = useNavigate();
    const { token } = useSelector((state) => state.auth);
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const { dropdownCategories = [] } = useSelector((state) => state.category);

    const [copied, setCopied] = useState(false);

    const handleCopy = (url) => {
        navigator.clipboard.writeText(url);
        setCopied(true);
        setTimeout(() => setCopied(false), 1000);
    };

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const res = await axios.get(
                    `${process.env.REACT_APP_API_URL}/api/orders/my-orders`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );
                setOrders(res.data.data);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [token]);

    const getStatusBadgeClass = (status) => {
        const statusClasses = {
            pending: "badge bg-warning",
            processing: "badge bg-info",
            shipped: "badge bg-primary",
            delivered: "badge bg-success",
            cancelled: "badge bg-danger",
        };
        return statusClasses[status?.toLowerCase()] || "badge bg-secondary";
    };

    const downloadInvoice = (order) => {
        const doc = new jsPDF();

        const themeColor = [249, 230, 168];
        const themeTextColor = [80, 60, 0];

        doc.setFillColor(...themeColor);
        doc.rect(0, 0, 210, 45, "F");

        try {
            doc.addImage(Logo, "PNG", 14, 10, 35, 14);
        } catch (e) {
            doc.setTextColor(...themeTextColor);
            doc.setFontSize(20);
            doc.setFont("helvetica", "bold");
            doc.text("Shaart", 14, 22);
        }

        doc.setTextColor(...themeTextColor);
        doc.setFontSize(9);
        doc.setFont("helvetica", "normal");
        doc.text("shaart.zentarq.com  |  +91 8248418010", 14, 36);

        doc.setFontSize(26);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(...themeTextColor);
        doc.text("INVOICE", 148, 28);

        doc.setTextColor(0, 0, 0);

        doc.setFontSize(10);
        const infoStartY = 55;

        doc.setFont("helvetica", "bold");
        doc.text("Invoice Details", 14, infoStartY);
        doc.setFont("helvetica", "normal");
        doc.text(`Invoice No   :  #${order._id.slice(-8).toUpperCase()}`, 14, infoStartY + 8);
        doc.text(
            `Invoice Date :  ${new Date(order.createdAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "long",
                year: "numeric",
            })}`,
            14,
            infoStartY + 16
        );
        doc.text(`Payment      :  ${order.payment?.method || "Cash on Delivery"}`, 14, infoStartY + 24);

        const statusColors = {
            pending: [255, 193, 7],
            processing: [13, 202, 240],
            shipped: [13, 110, 253],
            delivered: [25, 135, 84],
            cancelled: [220, 53, 69],
        };
        const statusColor = statusColors[order.status?.toLowerCase()] || [108, 117, 125];
        doc.setFillColor(...statusColor);
        doc.roundedRect(130, infoStartY + 4, 40, 10, 3, 3, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.text((order.status || "IN PROGRESS").toUpperCase(), 150, infoStartY + 11, { align: "center" });
        doc.setTextColor(0, 0, 0);

        doc.setDrawColor(249, 230, 168);
        doc.setLineWidth(1);
        doc.line(14, infoStartY + 35, 196, infoStartY + 35);
        doc.setLineWidth(0.2);

        const addressY = infoStartY + 42;
        if (order.shippingAddress) {
            doc.setFont("helvetica", "bold");
            doc.setFontSize(10);
            doc.text("Bill To:", 14, addressY);
            doc.setFont("helvetica", "normal");
            const addr = order.shippingAddress;
            doc.text(`${addr.fullName || ""}`, 14, addressY + 8);
            doc.text(`${addr.addressLine1 || addr.street || ""}`, 14, addressY + 15);
            doc.text(
                `${addr.district || ""}, ${addr.state || ""} - ${addr.pincode || addr.zip || ""}`,
                14,
                addressY + 22
            );
            doc.text(`Phone: ${addr.phone || ""}`, 14, addressY + 29);
        }

        const tableStartY = order.shippingAddress ? addressY + 40 : addressY;

        autoTable(doc, {
            startY: tableStartY,
            head: [["Si", "Product Name", "Qty", "Unit Price", "Color", "Subtotal"]],
            body: order.items.map((item, index) => [
                index + 1,
                item.name,
                item.quantity,
                `Rs. ${Number(item.price).toFixed(2)}`,
                item.frameColor || "N/A",
                `Rs. ${(item.price * item.quantity).toFixed(2)}`,
            ]),
            theme: "grid",
            headStyles: {
                fillColor: [249, 230, 168],
                textColor: [80, 60, 0],
                fontStyle: "bold",
                fontSize: 10,
            },
            bodyStyles: {
                fontSize: 9,
                textColor: [40, 40, 40],
            },
            alternateRowStyles: {
                fillColor: [254, 249, 235],
            },
         columnStyles: {
    0: { cellWidth: 10, halign: "center" },
    2: { halign: "center" },
    3: { halign: "right" },
    4: { halign: "center", textColor: [255, 255, 255] }, // hide all text by default
    5: { halign: "right" },
},

didDrawCell: (data) => {
    if (data.column.index === 4 && data.section === "body") {
        const colorValue = data.cell.raw;

        if (colorValue && colorValue !== "N/A") {
            const isHex = /^#?[0-9A-Fa-f]{6}$/.test(colorValue);

            if (isHex) {
                // Draw colored circle and keep text hidden (white)
                const hex = colorValue.replace("#", "");
                const r = parseInt(hex.substring(0, 2), 16);
                const g = parseInt(hex.substring(2, 4), 16);
                const b = parseInt(hex.substring(4, 6), 16);

                const x = data.cell.x + data.cell.width / 2;
                const y = data.cell.y + data.cell.height / 2;
                doc.setFillColor(r, g, b);
                doc.circle(x, y, 3, "F");
                doc.setDrawColor(180, 180, 180);
                doc.setLineWidth(0.3);
                doc.circle(x, y, 3, "S");

            } else {
                // Plain name like "pink" — draw it manually in dark color
                // since columnStyles made it white
                doc.setTextColor(40, 40, 40);
                doc.setFontSize(9);
                const x = data.cell.x + data.cell.width / 2;
                const y = data.cell.y + data.cell.height / 2 + 3;
                doc.text(String(colorValue), x, y, { align: "center" });
            }
        }
    }
},
        });

        const finalY = doc.lastAutoTable.finalY + 8;

        doc.setFillColor(254, 249, 235);
        doc.rect(120, finalY, 76, 22, "F");

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(80, 80, 80);
        doc.text("Subtotal:", 125, finalY + 8);
        doc.text(`Rs. ${Number(order.totalAmount).toFixed(2)}`, 194, finalY + 8, { align: "right" });

        doc.setDrawColor(...themeColor);
        doc.setLineWidth(1);
        doc.line(120, finalY + 12, 196, finalY + 12);
        doc.setLineWidth(0.2);

        doc.setFont("helvetica", "bold");
        doc.setFontSize(11);
        doc.setTextColor(80, 60, 0);
        doc.text("Total Amount:", 125, finalY + 20);
        doc.text(`Rs. ${Number(order.totalAmount).toFixed(2)}`, 194, finalY + 20, { align: "right" });

        doc.setTextColor(150, 150, 150);
        doc.setFontSize(8);
        doc.setFont("helvetica", "italic");
        doc.text("Thank you for shopping with us!", 105, finalY + 35, { align: "center" });
        doc.text("For queries, contact 8248418010", 105, finalY + 41, { align: "center" });

        doc.save(`Invoice_${order._id.slice(-8).toUpperCase()}.pdf`);
    };

    if (loading) {
        return (
            <div className="content-inner-1">
                <div className="container">
                    <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading orders...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="page-wraper">
            <Header dropdownCategories={dropdownCategories} loading={loading} />
            <div className="content-inner-1 bg-light">
                <div className="container">
                    <div className="row">
                        <section className="col-xl-12 account-wrapper marginTOP100">
                            <h3 className="mb-4">My Orders</h3>

                            {orders.length === 0 ? (
                                <div className="account-card text-center py-5">
                                    <i className="fas fa-shopping-bag fa-3x text-muted mb-3"></i>
                                    <h5>No orders found</h5>
                                    <p className="text-muted">You haven't placed any orders yet.</p>
                                    
                                    <a    onClick={() => navigate("/")}
                                        className="btn btn-primary mt-3"
                                    >
                                        Start Shopping
                                    </a>
                                </div>
                            ) : (
                                orders.map((order) => (
                                    <div key={order._id} className="account-card order-details mb-4">
                                        <div className="order-head">
                                            <div className="clearfix m-l20">
                                                <div className={getStatusBadgeClass(order.status)}>
                                                    {order.status || "In Progress"}
                                                </div>
                                                <h4 className="mb-0">Order #{order.orderId}</h4>
                                            </div>
                                        </div>

                                        <div className="row mb-sm-4 mb-2">
                                            <div className="col-sm-6">
                                                <div className="shiping-tracker-detail">
                                                    <span>Items</span>
                                                    <h6 className="title">
                                                        {order.items?.length || 0} item(s)
                                                    </h6>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="shiping-tracker-detail">
                                                    <span>Total Amount</span>
                                                    <h6 className="title">₹{order.totalAmount}</h6>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="shiping-tracker-detail">
                                                    <span>Order Date</span>
                                                    <h6 className="title">
                                                        {new Date(order.createdAt).toLocaleDateString(
                                                            "en-GB",
                                                            {
                                                                day: "2-digit",
                                                                month: "long",
                                                                year: "numeric",
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                            }
                                                        )}
                                                    </h6>
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="shiping-tracker-detail">
                                                    <span>Payment Method</span>
                                                    <h6 className="title">
                                                        {order.payment.method || "Cash on Delivery"}
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="content-btn m-b15">
                                            
                                            <a    onClick={() => downloadInvoice(order)}
                                                className="btn btn-outline-secondary m-b15 me-xl-3 me-2 btnhover20"
                                            >
                                                Download Invoice
                                            </a>
                                        </div>

                                        {/* Order Items Preview */}
                                        <div className="order-items-preview mt-3">
                                            <div className="row g-3 mt-2">
                                                <div className="col-md-6">
                                                    <h6 className="mb-3">Items in this order:</h6>
                                                    {order.items?.map((item, index) => (
                                                        <div key={index} className="tracking-item mb-2">
                                                            <div className="tracking-product">
                                                                {item.images?.map((img, i) => (
                                                                    <img
                                                                        key={i}
                                                                        src={`${process.env.REACT_APP_API_URL}/uploads/${img}`}
                                                                        alt="Product"
                                                                        style={{
                                                                            width: "60px",
                                                                            height: "60px",
                                                                            objectFit: "cover",
                                                                            marginRight: "6px",
                                                                        }}
                                                                    />
                                                                ))}
                                                            </div>
                                                            <div className="tracking-product-content">
                                                                <small className="d-block">
                                                                    <strong>Product Name:</strong> {item.name}
                                                                </small>
                                                                <small className="d-block">
                                                                    <strong>Price:</strong> ₹{item.price}
                                                                </small>
                                                                <small className="d-block">
                                                                    <strong>Quantity:</strong> {item.quantity}
                                                                </small>
                                                                <small className="d-block" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                                    <strong>Color:</strong>
                                                                    {item.frameColor ? (
                                                                        <>
                                                                            <span
                                                                                style={{
                                                                                    display: "inline-block",
                                                                                    width: "16px",
                                                                                    height: "16px",
                                                                                    borderRadius: "50%",
                                                                                    backgroundColor: item.frameColor || item.productColor,
                                                                                    border: "1px solid #ccc",
                                                                                    marginLeft: "6px",
                                                                                    verticalAlign: "middle"
                                                                                }}
                                                                            />
                                                                            &nbsp;{item.frameColor}
                                                                        </>
                                                                    ) : (
                                                                        <span>N/A</span>
                                                                    )}
                                                                </small>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>

                                                <div className="col-md-6 JUstifyCont">
                                                    {order.trackingUrl ? (
                                                        <div className="mt-3 p-3 bg-light rounded borderR overFLow">
                                                            <small className="text-muted d-block mb-1 headeR">
                                                                Tracking Url:
                                                            </small>
                                                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                                                
                                                                 <a   href={order.trackingUrl}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="text-primary fw-medium Ellips"
                                                                >
                                                                    {order.trackingUrl}
                                                                </a>
                                                                <button
                                                                    onClick={() => handleCopy(order.trackingUrl)}
                                                                    title={copied ? "Copied!" : "Copy URL"}
                                                                    style={{
                                                                        background: "none",
                                                                        border: "none",
                                                                        cursor: "pointer",
                                                                        padding: "2px",
                                                                        flexShrink: 0,
                                                                    }}
                                                                >
                                                                    {copied ? (
                                                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="green" strokeWidth="2">
                                                                            <polyline points="20 6 9 17 4 12" />
                                                                        </svg>
                                                                    ) : (
                                                                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="2">
                                                                            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
                                                                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                                                                        </svg>
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="mt-3 p-3 bg-light rounded borderR">
                                                            <small className="text-muted">
                                                                Tracking not available yet
                                                            </small>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )}
                        </section>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default MyOrders;